@file:OptIn(InternalResourceApi::class)

package soundgame.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/soundgame.app.shared.generated.resources/"

@delegate:ResourceContentHash(548_952_831)
internal val Res.string.host_screen_greeting: StringResource by lazy {
      StringResource("string:host_screen_greeting", "host_screen_greeting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 44),
      ))
    }

@delegate:ResourceContentHash(-1_720_235_253)
internal val Res.string.host_screen_start_button: StringResource by lazy {
      StringResource("string:host_screen_start_button", "host_screen_start_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 55, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("host_screen_greeting", Res.string.host_screen_greeting)
  map.put("host_screen_start_button", Res.string.host_screen_start_button)
}
